/**
 * Shared palette for channel badges — distinct hues, balanced saturation.
 * Used for random assignment on create and for fallback when channel has no color.
 */
export const CHANNEL_COLOR_PALETTE = [
  '#3E63DD', // indigo
  '#8E4EC6', // purple
  '#E93D82', // pink
  '#E5484D', // red
  '#F76B15', // orange
  '#EEC643', // gold
  '#46A758', // green
  '#12A594', // teal
  '#00A2C7', // cyan
  '#0090FF', // blue
  '#6E56CF', // violet
  '#D6409F', // magenta
  '#0D74CE', // cerulean
  '#30A46C', // jade
  '#978365', // sand
];

/**
 * Returns a random hex color from the channel palette.
 */
export function pickRandomChannelColor() {
  const idx = Math.floor(Math.random() * CHANNEL_COLOR_PALETTE.length);
  return CHANNEL_COLOR_PALETTE[idx];
}
